var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-3 text-center grey--text"},[_vm._v("No data is available yet")])
}
var staticRenderFns = []

export { render, staticRenderFns }